import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
// import extend from 'lodash/extend';
import chunk from 'lodash/chunk';
import { withRouter } from 'react-router';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';
import Slug from '../../../components/slug/slug';
import FCLink from '../../../components/fc_link/fc_link';
import legacyImageAssetUtil from '../../../../utils/legacy_image_asset_util';

function Company(company) {
  return (
    <div key={`company-${company.name}`}>
      <FCLink to={`/company/${company.url}`}><h2>{company.name}</h2></FCLink>
    </div>
  );
}

function CompanySection(companies) {
  return (
    <section key={`section-${get(companies, '[0].name')}`}>
      {companies.map(Company)}
    </section>
  );
}

function SectorCompany(company) {
  return (
    <div key={`company-${company.name}`}>
      <FCLink to={`/company/${company.url}`}>
        <h4>{company.name}</h4>
      </FCLink>
    </div>
  );
}

function SectorSection(year) {
  return function SectorSectionComponent(sector) {
    return (
      <section key={`section-${get(sector, 'name')}`}>
        <FCLink to={`/most-innovative-companies/${year}/sectors/${sector.url}`}>
          <h2>{sector.name}</h2>
        </FCLink>
        {sector.list.map(SectorCompany)}
      </section>
    );
  };
}
/*
 import Ad from '../../../components/ad/ad';
 import Slug from '../../../components/slug/slug';
 import MCPSection from '../../../components/mcp_section/mcp_section';
 import FeatureFeed from '../../../components/feature_feed/feature_feed';
 import { isAdvertorial } from '../../../components/advertorial/advertorial';
 */

// eslint-disable-next-line react/prefer-stateless-function
class MicYear extends Component {
  render() {
    if (this.props.micYearPage.error || this.props.status === 404) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.micYearPage.isLoading) {
      return (
        <section className="most-creative-people-page">
          <article className="most-creative-people-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    /*
     const adData = get(this.props, 'micYearPage.ads');
     const combinedAdModel = extend({},
     { baseConfig: get(adData, 'config.baseConfig') },
     { definitions: get(adData, 'config.definitions') },
     { model: get(adData, 'model') }
     );

     const year = get(this.props, 'match.params.year');
     const tags = get(this.props, 'tagAllFeed.posts[0].tags');
     const advertorial = isAdvertorial(tags);
     const pgTitle = `The Most Creative People In Business ${year}`;
     const sectionTitle = `Meet The 100 Most Creative People in Business ${year}`;
     const mcpList = get(this.props, 'micYear');
     const mcpSections = mcpList.map((people, index) => ({ id: `section-${index + 1}`, people }));
     const featuredFeed = get(this.props, 'micYearFeaturedFeed');
     const scrollingModule = get(this.props, 'micYearScrollingModule');

     const uri = encodeURIComponent(`https://www.fastmic.com/most-creative-people/${year}`);
     */
    return (
      <section className={`tag-page`}>
        <section className="page-title">
          <Slug
            slugName={`Most Innovative Companies ${this.props.year}`}
            className="category-page"
          />
        </section>
        <section>
          <img
            src={legacyImageAssetUtil(
              get(this.props, 'micYearDescription.data.rows[0].logo_url')
            )}
            alt=""
          />
          <p
            dangerouslySetInnerHTML={{
              __html:
                get(this.props, 'micYearDescription.data.rows[0].intro') || ''
            }}
          />
        </section>
        {this.props.micYear.map(CompanySection)}
        <section className="page-title">
          <Slug
            slugName={`${this.props.year} / Sectors`}
            className="category-page"
          />
        </section>
        {this.props.micSector.map(SectorSection(this.props.micYear))}
      </section>
    );
  }
}

/* eslint-disable */
function mapStateToProps(state = {}) {
  const micData = chunk(get(state, 'micYear.data.rows'), 10);
  return {
    config: state.config || {},
    status: state.status.code,
    micYearPage: get(state, 'micYearPage') || {error: true},
    micYear: micData || {error: true},
    year: get(state, 'micYear.year'),
    micSector: get(state, 'micSector.data.rows'),
    micYearDescription: get(state, 'micYearDescription'),
    micYearFeaturedFeed: get(state, 'micYearFeaturedFeed') || {error: true},
    micYearScrollingModule: get(state, 'micYearScrollingModule.data') || {error: true}
  };
}

MicYear.propTypes = {
  status: PropTypes.number,
  micYearPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }),
  year: PropTypes.string,
  micYear: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({})
    )
  ),
  micYearDescription: PropTypes.shape({}),
  micSector: PropTypes.arrayOf(
      PropTypes.shape({})
  ),
  micYearFeaturedFeed: PropTypes.shape({}),
  micYearScrollingModule: PropTypes.shape({})
};

MicYear.defaultProps = {};
/* eslint-enable */

export default withRouter(connect(mapStateToProps)(MicYear));



// WEBPACK FOOTER //
// ./src/views/containers/pages/mic_year_page/mic_year_page.js